module.exports = __webpack_public_path__ + "static/media/dots1.5fc5cafb.png";